// extracted by mini-css-extract-plugin
module.exports = {"graphContainer":"ReportsTable_graphContainer__3syYX","noContentContainer":"ReportsTable_noContentContainer__2zCOZ"};